import type { BaseAPI } from './helpers';

const appraisal = 'appraisal';

type Resource = {
  api?: BaseAPI;
  controller: string;
  resource: string;
  version: number;
};

const GetAppraisalByAppraisalId: Resource = {
  controller: appraisal,
  resource: '',
  version: 3
};

const RecordAnalytics: Resource = {
  controller: 'Analytics',
  resource: '',
  version: 4
};

export type AxiosResponse<T> = {
  data: {
    content: T;
  };
};

export { GetAppraisalByAppraisalId, RecordAnalytics, Resource };
